import { useProfile } from "../context/ProfileContext";
import { ArrowDown } from "lucide-react";

export default function Hero() {
  const PROFILE = useProfile();
  return (
    <section
      id="top"
      className="relative min-h-[100svh] w-full overflow-hidden bg-[#0A0A0A] pt-16"
      data-testid="hero-section"
    >
      {/* BG image */}
      <div className="absolute inset-0">
        <img
          src={PROFILE.images.hero}
          alt={PROFILE.name}
          className="w-full h-full object-cover object-top opacity-70"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0A] via-[#0A0A0A]/40 to-[#0A0A0A]/30" />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0A0A0A]/80 via-transparent to-[#0A0A0A]/20" />
      </div>

      {/* Side label */}
      <div className="hidden lg:flex absolute left-6 top-1/2 -translate-y-1/2 -rotate-90 origin-left z-10">
        <span className="text-[10px] tracking-[0.45em] uppercase text-[#8A8A8A]">
          Class of 2027 · Recruiting Now
        </span>
      </div>

      <div className="relative z-10 max-w-screen-2xl mx-auto px-6 sm:px-8 lg:px-12 min-h-[calc(100svh-4rem)] flex flex-col justify-end pb-16 lg:pb-24">
        <div className="rise">
          <span className="inline-flex items-center gap-2 text-[11px] tracking-[0.3em] uppercase text-[#E60000] font-bold mb-6">
            <span className="w-6 h-px bg-[#E60000]" />
            D1 Volleyball Recruit
          </span>
        </div>

        <h1
          className="font-display font-black uppercase text-white leading-[0.85] tracking-tighter rise rise-d1"
          style={{ fontSize: "clamp(3.5rem, 12vw, 10rem)" }}
          data-testid="hero-name"
        >
          Faith
          <br />
          <span className="text-[#E60000]">Ahyi-Sena</span>
        </h1>

        <div className="mt-8 lg:mt-12 grid grid-cols-2 md:grid-cols-4 border-t border-white/15 rise rise-d2" data-testid="hero-vitals">
          {[
            { k: "Position", v: "Middle Blocker" },
            { k: "Height", v: PROFILE.height },
            { k: "Class", v: PROFILE.classYear },
            { k: "Jersey", v: `#${PROFILE.clubJersey} / #${PROFILE.schoolJersey}` },
          ].map((s, i) => (
            <div
              key={s.k}
              className={`border-b border-white/15 px-4 py-5 ${i < 3 ? "border-r border-white/15" : ""}`}
            >
              <div className="text-[10px] tracking-[0.25em] uppercase text-[#E60000] font-bold mb-2">
                {s.k}
              </div>
              <div className="font-display text-2xl md:text-3xl uppercase font-bold text-white tracking-tight">
                {s.v}
              </div>
            </div>
          ))}
        </div>

        <div className="mt-10 flex items-center gap-6 rise rise-d3">
          <a
            href="#contact"
            className="inline-flex items-center gap-3 bg-[#E60000] hover:bg-[#FF3333] text-white px-7 py-4 text-xs tracking-[0.25em] uppercase font-bold transition-colors"
            data-testid="hero-contact-cta"
          >
            Contact Faith
          </a>
          <a
            href="#film"
            className="inline-flex items-center gap-3 text-white text-xs tracking-[0.25em] uppercase font-bold border-b border-white/30 pb-1 hover:border-[#E60000] hover:text-[#E60000] transition-colors"
            data-testid="hero-film-cta"
          >
            Watch Film
            <ArrowDown size={14} strokeWidth={2.5} />
          </a>
        </div>
      </div>

      {/* Bottom marquee */}
      <div className="absolute bottom-0 left-0 right-0 border-t border-white/10 bg-black/70 backdrop-blur-md overflow-hidden">
        <div className="flex marquee-track whitespace-nowrap py-3">
          {[...Array(2)].map((_, k) => (
            <div key={k} className="flex items-center gap-12 px-6 shrink-0">
              {[
                "6'1\" MIDDLE BLOCKER",
                "APPROACH 10'2\"",
                "BLOCK 9'10\"",
                "GPA 3.7 · ACT 31",
                "A5 17-2 ANGEL",
                "WESTMINSTER WILDCATS",
                "ATLANTA, GA",
                "CLASS OF 2027",
              ].map((t, i) => (
                <span
                  key={i}
                  className="font-display uppercase text-xs tracking-[0.3em] text-[#8A8A8A] flex items-center gap-12"
                >
                  {t}
                  <span className="w-1.5 h-1.5 bg-[#E60000]" />
                </span>
              ))}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
